export default __webpack_public_path__ + "media/src/assets/images/suggest_time-ea11b10f91fe4d55e496385cd79b29bb.svg";